import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Injectable } from '@angular/core';
import {
  PaymentAccountsGuestCheckoutService,
  PaymentAccountsPaymentLinksService,
  PaymentAccountsPlatformService,
  PaymentAccountsService,
} from '../services';

export const paymentAccountsServiceFactory = (
  httpClient: HttpClient,
  appConfig: AppConfigSettings,
) => {
  let service: PaymentAccountsService;

  if (appConfig.getconfig('usePaymentLinkEndpoints') === 'true') {
    service = new PaymentAccountsPaymentLinksService(httpClient, appConfig);
  } else if (appConfig.getconfig('useHostedPaymentsPageEndpoints') === 'true') {
    service = new PaymentAccountsGuestCheckoutService(httpClient, appConfig);
  } else {
    service = new PaymentAccountsPlatformService(httpClient, appConfig);
  }

  return service;
};

@Injectable({
  providedIn: 'root',
})
export class PaymentAccountsServiceFactory {
  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigSettings,
  ) {}

  create() {
    return paymentAccountsServiceFactory(this.httpClient, this.appConfig);
  }
}
